import { useSelector } from 'react-redux';
import FormSidebar from '../FormSidebar';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';

const CareerFormSidebar = () => {
    const { cta_description } = useSelector(selectTranslations);

    return (
        <FormSidebar>
            <div className="career-form">
                <p className="description-medium">{cta_description}</p>
                {/* <p className="description-medium">For all career-related questions, you can contact our manager:</p>
                <a href="/#" className="mail description-demibold">
                    nadia@uniferx.com
                </a> */}
            </div>
        </FormSidebar>
    );
};
export default CareerFormSidebar;
